// This file is imported by all apps and logs the app version and build date to the console
// It is used to verify that the correct version of the app is running in the browser
import env from "#/env";

// eslint-disable-next-line no-console
console.log(
  `%cIS-POKK UI v${env.APP_VERSION}, Build date: ${env.APP_BUILD_DATE}`,
  "font-weight: bold; font-size: 1.5em; padding: .2em 0 0 0;"
);
